import { render, staticRenderFns } from "./RptCovidReport.vue?vue&type=template&id=4ebc92f9&scoped=true&"
import script from "./RptCovidReport.vue?vue&type=script&lang=js&"
export * from "./RptCovidReport.vue?vue&type=script&lang=js&"
import style0 from "./RptCovidReport.vue?vue&type=style&index=0&id=4ebc92f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc92f9",
  null
  
)

export default component.exports